var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWebsite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 45.3 45.6",
    enableBackground: "new 0 0 45.3 45.6",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#111B44",
    stroke: "#FFFFFF",
    strokeWidth: 1.3469,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 22.1,
    cy: 23.1,
    r: 18.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 1.3469,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 22.1,
    cy: 23.1,
    rx: 7,
    ry: 18.9
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9368b7",
    stroke: "#FFFFFF",
    strokeWidth: 1.3469,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M22.1,13.4c-5.5,0-10.5-1.2-13.9-3c-3.1,3.4-4.9,7.8-4.9,12.7c0,4.9,1.9,9.3,4.9,12.7c3.4-1.8,8.4-3,13.9-3c5.5,0,10.5,1.2,13.9,3 c3.1-3.4,4.9-7.8,4.9-12.7c0-4.9-1.9-9.3-4.9-12.7C32.5,12.3,27.6,13.4,22.1,13.4z"
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 1.3469,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 18,20.4 20,25.8 22.1,21.1 24,25.8 26.1,20.4  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 1.3469,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 30.8,20.4 32.7,25.8 34.9,21.1 36.7,25.8 38.8,20.4  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 1.3469,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 5.1,20.4 7,25.8 9.2,21.1 11,25.8 13.1,20.4  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsite);
export default __webpack_public_path__ + "static/media/website.f0fd00b2c5ecd3f3714f7cc5b6faffb4.svg";
export { ForwardRef as ReactComponent };